module.exports = __webpack_public_path__ + "img/linkedin-icon.3a49043a.svg";